import React from "react";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";
import { withRouter } from "./withRouter";
import { Result } from "antd";
import { config } from "../config/GeneralConfig";

export default function withAuth(Component) {
  class InnerHoc extends React.Component {
    cookies = new Cookies();

    isAuthenticated = () => {
      const token = this.cookies.get("_bbn_tn");
      const username = this.cookies.get("_bbn_un");

      return token && username !== "cm9yYQ=="; // base64 of "rora"
    };

    getCurrentProjectCode = () => {
      const pathname = this.props.location.pathname;
      const match = pathname.match(/^\/([^/]+)/); // ambil kode project dari URL
      return match ? match[1] : null;
    };

    hasProjectAccess = () => {
      const currentCode = this.getCurrentProjectCode();
      const listProject = JSON.parse(atob(this.cookies.get("_bbn_ls")));
      if (!listProject[currentCode]) {
        return false;
      }

      return currentCode;
    };

    hasMenuAccess = () => {
      const listMenu = config.list_menu;
      const menuAccessIds = this.cookies.get("_bbn_m");

      const pathname = this.props.location.pathname;
      const path = pathname.replace(/^\/[^/]+/, "");

      const matchedMenu = listMenu.find((menu) => menu.link === path);

      if (!matchedMenu) return false;

      return menuAccessIds.includes(matchedMenu.id);
    };

    render() {
      if (!this.isAuthenticated()) {
        console.log("auth: not authenticated");
        return <Navigate to="/login" />;
      }

      if (!this.hasProjectAccess()) {
        console.log("auth: no access to this project");
        return <Result status="403" title="403 - Forbidden" subTitle="Anda tidak memiliki akses ke project ini." />;
      }

      if (!this.hasMenuAccess()) {
        console.log("auth: no access to this menu");
        return <Result status="403" title="403 - Forbidden" subTitle="Anda tidak memiliki hak akses ke halaman ini." />;
      }

      return <Component {...this.props} />;
    }
  }

  return withRouter(InnerHoc);
}
